module.exports = __webpack_public_path__ + "static/media/Event-Findr.3b523573.png";